import { motion, useInView } from "framer-motion"
import { graphql, Link } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"

const ExporeDetails = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  const [activeItem, setActiveItem] = useState(1)

  const handleAccordionClick = index => {
    setActiveItem(index === activeItem ? null : index)
  }
  const [isMObile, setIsMObile] = useState(false)

  useEffect(() => {
    if (window.innerWidth < 992) {
      setIsMObile(true)
    } else {
      setIsMObile(false)
    }
  }, [setIsMObile])

  if (module.hideSection === "no") {
    return (
      <motion.section
        initial="hidden"
        animate={isInView || hasPlayed ? "show" : "hidden"}
        variants={sectionShow}
        className={`content-grid${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <motion.div
          ref={ref}
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className="container-fluid"
        >
          <div className="bg-white-100 py-60 px-80 lgscreen:p-30 lgscreen:pb-20 lgscreen:px-40 mdscreen:px-20">
            <div className="flex flex-wrap justify-between border-b-1 border-charcoal pb-60 mdscreen:pb-0 mdscreen:border-0">
              {isMObile && (
                <div className="lg:w-3/12 md:w-4/12 ipad:w-full xlscreen:w-[35%] ipad:border-b-1 ipad:border-charcoal ipad:pb-30 hidden ipad:block">
                  <div className="block">
                    <div className="grid gap-y-8 ipad:pl-60 smscreen:pl-50 ">
                      <div className="content-blog accordion">
                        <div
                          className={`accordion__item ${
                            activeItem === 1 ? "open" : "close"
                          }`}
                        >
                          {module?.openingHour && (
                            <motion.h6 variants={animFade}>
                              <button
                                className="AccordionItemButton relative outline-none w-full text-left ipad:flex ipad:flex-wrap ipad:items-center ipad:gap-x-3"
                                onClick={() => handleAccordionClick(1)}
                              >
                                <img
                                  src="../../images/clock.svg"
                                  width={15}
                                  height={15}
                                  loading="lazy"
                                  alt="Clock"
                                  className="hidden ipad:block relative -top-2"
                                />
                                <h6>{module.openingHour}</h6>
                              </button>
                            </motion.h6>
                          )}
                          <div className="accordian-content-wrapper">
                            <div className="accordian-content">
                              {module?.openingHourDetails && (
                                <div className="flex flex-wrap items-start gap-x-2 pt-5">
                                  <div className="w-[15px]">
                                    <img
                                      src="../../images/clock.svg"
                                      width={15}
                                      height={15}
                                      loading="lazy"
                                      alt="Clock"
                                      className="relative top-2 block ipad:hidden"
                                    />
                                  </div>
                                  <motion.div
                                    variants={animFade}
                                    className="grid leading-18 ipad:pl-[3px] w-[90%]"
                                  >
                                    {parse(module.openingHourDetails)}
                                  </motion.div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="content-blog accordion">
                        <div
                          className={`accordion__item ${
                            activeItem === 2 ? "open" : "close"
                          }`}
                        >
                          {module?.location && (
                            <motion.div variants={animFade}>
                              <button
                                className="AccordionItemButton relative outline-none w-full text-left ipad:flex ipad:flex-wrap ipad:items-center ipad:gap-x-3"
                                onClick={() => handleAccordionClick(2)}
                              >
                                <img
                                  src="../../images/location-black.svg"
                                  width={15}
                                  height={15}
                                  loading="lazy"
                                  alt="Location"
                                  className="hidden ipad:block relative -top-2"
                                />
                                <h6>{module.location}</h6>
                              </button>
                            </motion.div>
                          )}

                          {module?.locationDetails &&
                            module.locationDetails.map((item, i) => (
                              <div
                                className="accordian-content-wrapper"
                                key={i}
                              >
                                <div className="accordian-content">
                                  <div className="flex flex-wrap items-start gap-x-2 pt-5">
                                    {item?.address && (
                                      <div className="w-[15px]">
                                        <img
                                          src="../../images/location-black.svg"
                                          width={15}
                                          height={15}
                                          loading="lazy"
                                          alt="Location"
                                          className="relative top-2 block ipad:hidden"
                                        />
                                      </div>
                                    )}
                                    <motion.div
                                      variants={animFade}
                                      className="grid leading-18 ipad:pl-[3px] w-[90%] mdscreen:w-[75%]"
                                    >
                                      {item?.address && (
                                        <span className="font-ositalic text-13">
                                          {parse(item.address)}
                                        </span>
                                      )}
                                      {item?.mapLink && (
                                        <Link
                                          to={item.mapLink.url}
                                          className="font-ositalic normal-case underline mt-10 hover:opacity-50"
                                          target="_blank"
                                        >
                                          View on Google Maps
                                        </Link>
                                      )}
                                    </motion.div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                      <div className="content-blog accordion">
                        <div
                          className={`accordion__item ${
                            activeItem === 3 ? "open" : "close"
                          }`}
                        >
                          {module?.contact && (
                            <motion.h6 variants={animFade}>
                              <button
                                className="AccordionItemButton relative outline-none w-full text-left ipad:flex ipad:flex-wrap ipad:items-center ipad:gap-x-3"
                                onClick={() => handleAccordionClick(3)}
                              >
                                <img
                                  src="../../images/call.svg"
                                  width={15}
                                  height={15}
                                  loading="lazy"
                                  alt="Call"
                                  className="hidden ipad:block relative -top-2"
                                />
                                <h6>{module.contact}</h6>
                              </button>
                            </motion.h6>
                          )}

                          {module.contactDetails &&
                            module.contactDetails.map((item, i) => (
                              <div
                                className="accordian-content-wrapper"
                                key={i}
                              >
                                <motion.div
                                  variants={animFade}
                                  className="accordian-content ipad:pl-[3px]"
                                >
                                  {item?.location && (
                                    <div className="flex flex-wrap gap-x-2 pt-5">
                                      <div className="w-[15px]">
                                        <img
                                          src="../../images/location-black.svg"
                                          width={15}
                                          height={15}
                                          loading="lazy"
                                          alt="phone"
                                          className="block ipad:hidden mt-[4px]"
                                        />
                                      </div>
                                      <p className="font-ositalic normal-case hover:opacity-50">
                                        {item.location}
                                      </p>
                                    </div>
                                  )}

                                  {item?.phone && (
                                    <div className="flex flex-wrap gap-x-2 pt-5">
                                      <div className="w-[15px]">
                                        <img
                                          src="../../images/phone.svg"
                                          width={10}
                                          height={12}
                                          loading="lazy"
                                          alt="phone"
                                          className="block ipad:hidden mt-[2px] mx-auto"
                                        />
                                      </div>
                                      <Link
                                        to={`tel:${item.phone}`}
                                        className="font-ositalic normal-case underline hover:opacity-50"
                                      >
                                        {item.phone}
                                      </Link>
                                    </div>
                                  )}
                                  {item?.email && (
                                    <div className="flex flex-wrap gap-x-2 pt-5">
                                      <div className="w-[15px]">
                                        <img
                                          src="../../images/email.svg"
                                          width={15}
                                          height={15}
                                          loading="lazy"
                                          alt="mail"
                                          className="block ipad:hidden mt-[4px]"
                                        />
                                      </div>
                                      <Link
                                        to={`mailto:${item.email}`}
                                        className="font-ositalic normal-case underline hover:opacity-50"
                                      >
                                        {item.email}
                                      </Link>
                                    </div>
                                  )}
                                </motion.div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  <motion.div
                    variants={animFade}
                    className="sicon-black flex flex-wrap mt-20 gap-x-4 smscreen2:justify-center ipad:hidden"
                  >
                    {module?.fbLink && (
                      <Link
                        to={module.fbLink}
                        className="transition-all duration-300"
                        target="_blank"
                      >
                        <img
                          src={module.fbIcon.mediaItemUrl}
                          width={33}
                          height={33}
                          loading="lazy"
                          alt={module.fbIcon.altText}
                        />
                      </Link>
                    )}
                    {module?.instaLink && (
                      <Link
                        to={module.instaLink}
                        className="transition-all duration-300"
                        target="_blank"
                      >
                        <img
                          src={module.instaIcon.mediaItemUrl}
                          width={33}
                          height={33}
                          loading="lazy"
                          alt={module.instaIcon.mediaItemUrl}
                        />
                      </Link>
                    )}
                  </motion.div>
                </div>
              )}
              <div className="lg:w-9/12 md:w-8/12 ipad:w-full xlscreen:w-[60%] max-w-[900px] desktop2:max-w-[600px] lgscreen:max-w-[400px] ipad:max-w-full ipad:pt-30 ipad:px-30">
                {module?.heading && (
                  <motion.h2 variants={animFade}>{module.heading}</motion.h2>
                )}
                {module?.description && (
                  <motion.div variants={animFade} className="content pt-15">
                    {parse(module.description)}
                  </motion.div>
                )}
                {module?.quoteLocation && (
                  <motion.div
                    variants={animFade}
                    className="flex flex-wrap items-end gap-x-2 pt-5 mt-[50px] lgscreen:mt-[20px]"
                  >
                    <div className="w-[15px]">
                      <img
                        src="../../images/location-black.svg"
                        width={15}
                        height={15}
                        loading="lazy"
                        alt="Clock"
                        className="relative top-2 block"
                      />
                    </div>
                    <div className="grid leading-[14px] ipad:pl-[3px] w-[90%] font-secondary italic">
                      {parse(module.quoteLocation)}
                    </div>
                  </motion.div>
                )}
                {module?.quote && (
                  <motion.div variants={animFade}>
                    <span className="font-ositalic text-19 mt-30 mdscreen:mt-15 inline-block w-full">
                      “{parse(module.quote)}”
                    </span>
                  </motion.div>
                )}
                {module?.quoteAuthor && (
                  <motion.div variants={animFade}>
                    <span className="text-12 mt-15 inline-block w-full text-color">
                      {module.quoteAuthor}
                    </span>
                  </motion.div>
                )}
              </div>
              <div className="lg:w-3/12 md:w-4/12 ipad:w-full xlscreen:w-[35%]  ipad:border-b-1 ipad:border-charcoal ipad:pb-30 block ipad:hidden">
                <div className="block ipad:hidden">
                  <div className="grid gap-y-8 ipad:pl-60 smscreen:pl-0 ">
                    <div className="content-blog accordion">
                      <div className={`accordion__item`}>
                        {module?.openingHour && (
                          <button className="AccordionItemButton relative outline-none w-full text-left ipad:flex ipad:flex-wrap ipad:items-center ipad:gap-x-3">
                            <img
                              src="../../images/clock.svg"
                              width={15}
                              height={15}
                              loading="lazy"
                              alt="Clock"
                              className="hidden ipad:block relative -top-2"
                            />
                            <motion.h6 variants={animFade}>
                              {module.openingHour}
                            </motion.h6>
                          </button>
                        )}
                        <div className="accordian-content-wrapper">
                          <div className="accordian-content">
                            {module?.openingHourDetails && (
                              <motion.div
                                variants={animFade}
                                className="flex flex-wrap items-start gap-x-2 pt-5"
                              >
                                <div className="w-[15px]">
                                  <img
                                    src="../../images/clock.svg"
                                    width={15}
                                    height={15}
                                    loading="lazy"
                                    alt="Clock"
                                    className="relative top-2 block ipad:hidden"
                                  />
                                </div>
                                <div className="grid leading-18 ipad:pl-[3px] w-[90%]">
                                  {parse(module.openingHourDetails)}
                                </div>
                              </motion.div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="content-blog accordion">
                      <div className={`accordion__item `}>
                        {module?.location && (
                          <button className="AccordionItemButton relative outline-none w-full text-left ipad:flex ipad:flex-wrap ipad:items-center ipad:gap-x-3">
                            <img
                              src="../../images/location-black.svg"
                              width={15}
                              height={15}
                              loading="lazy"
                              alt="Location"
                              className="hidden ipad:block relative -top-2"
                            />
                            <motion.h6 variants={animFade}>
                              {module.location}
                            </motion.h6>
                          </button>
                        )}
                        {module?.locationDetails &&
                          module.locationDetails.map((item, i) => (
                            <div className="accordian-content-wrapper" key={i}>
                              <div className="accordian-content">
                                <motion.div
                                  variants={animFade}
                                  className="flex flex-wrap items-start gap-x-2 pt-5"
                                >
                                  {item?.address && (
                                    <div className="w-[15px]">
                                      <img
                                        src="../../images/location-black.svg"
                                        width={15}
                                        height={15}
                                        loading="lazy"
                                        alt="Location"
                                        className="relative top-2 block ipad:hidden"
                                      />
                                    </div>
                                  )}
                                  <div className="grid leading-18 ipad:pl-[3px] w-[90%] mdscreen:w-[75%]">
                                    {item?.address && (
                                      <span className="font-ositalic text-13 addinfo">
                                        {parse(item.address)}
                                      </span>
                                    )}
                                    {item?.mapLink && (
                                      <Link
                                        to={item.mapLink.url}
                                        className="font-ositalic normal-case underline mt-10 hover:opacity-50"
                                        target="_blank"
                                      >
                                        View on Google Maps
                                      </Link>
                                    )}
                                  </div>
                                </motion.div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="content-blog accordion">
                      <div className={`accordion__item `}>
                        {module?.contact && (
                          <button className="AccordionItemButton relative outline-none w-full text-left ipad:flex ipad:flex-wrap ipad:items-center ipad:gap-x-3">
                            <img
                              src="../../images/call.svg"
                              width={15}
                              height={15}
                              loading="lazy"
                              alt="Call"
                              className="hidden ipad:block relative -top-2"
                            />
                            <motion.h6 variants={animFade}>
                              {module.contact}
                            </motion.h6>
                          </button>
                        )}

                        {module?.contactDetails &&
                          module.contactDetails.map((item, i) => (
                            <div className="accordian-content-wrapper" key={i}>
                              <div
                                className="accordian-content ipad:pl-[3px]"
                                key={i}
                              >
                                {item?.location && (
                                  <motion.div
                                    variants={animFade}
                                    className="flex flex-wrap gap-x-2 pt-5"
                                  >
                                    <div className="w-[15px]">
                                      <img
                                        src="../../images/location-black.svg"
                                        width={15}
                                        height={15}
                                        loading="lazy"
                                        alt="location"
                                        className="block ipad:hidden mt-[2px] mx-auto"
                                      />
                                    </div>
                                    <p className="font-ositalic normal-case hover:opacity-50">
                                      {item.location}
                                    </p>
                                  </motion.div>
                                )}
                                {item?.phone && (
                                  <motion.div
                                    variants={animFade}
                                    className="flex flex-wrap gap-x-2 pt-5"
                                  >
                                    <div className="w-[15px]">
                                      <img
                                        src="../../images/phone.svg"
                                        width={10}
                                        height={12}
                                        loading="lazy"
                                        alt="phone"
                                        className="block ipad:hidden mt-[2px] mx-auto"
                                      />
                                    </div>
                                    <Link
                                      to={`tel:${item.phone}`}
                                      className="font-ositalic normal-case underline hover:opacity-50"
                                    >
                                      {item.phone}
                                    </Link>
                                  </motion.div>
                                )}
                                {item?.email && (
                                  <motion.div
                                    variants={animFade}
                                    className="flex flex-wrap gap-x-2 pt-5"
                                  >
                                    <div className="w-[15px]">
                                      <img
                                        src="../../images/email.svg"
                                        width={15}
                                        height={15}
                                        loading="lazy"
                                        alt="mail"
                                        className="block ipad:hidden mt-[4px]"
                                      />
                                    </div>
                                    <Link
                                      to={`mailto:${item.email}`}
                                      className="font-ositalic normal-case underline hover:opacity-50"
                                    >
                                      {item.email}
                                    </Link>
                                  </motion.div>
                                )}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>

                <motion.div
                  variants={animFade}
                  className="sicon-black flex flex-wrap mt-20 gap-x-4 smscreen2:justify-center ipad:hidden"
                >
                  {module?.fbLink && (
                    <Link
                      to={module.fbLink}
                      className="transition-all duration-300"
                      target="_blank"
                    >
                      <img
                        src={module.fbIcon.mediaItemUrl}
                        width={33}
                        height={33}
                        loading="lazy"
                        alt={module.fbIcon.altText}
                      />
                    </Link>
                  )}
                  {module?.instaLink && (
                    <Link
                      to={module.instaLink}
                      className="transition-all duration-300"
                      target="_blank"
                    >
                      <img
                        src={module.instaIcon.mediaItemUrl}
                        width={33}
                        height={33}
                        loading="lazy"
                        alt={module.instaIcon.mediaItemUrl}
                      />
                    </Link>
                  )}
                </motion.div>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.section>
    )
  }
  return null
}

export default ExporeDetails
export const EatDrinkExporeDetailsFragment = graphql`
  fragment EatDrinkExporeDetailsFragment on WpEatDrink_Restaurantcontent_RestaurantContent_ExporeDetails {
    extraClass
    extraId
    hideSection
    heading
    description
    contact
    openingHour
    openingHourDetails
    quote
    quoteAuthor
    quoteLocation
    location
    contactDetails {
      email
      location
      phone
    }
    locationDetails {
      mapLink {
        target
        title
        url
      }
      address
    }
    fbLink
    fbIcon {
      altText
      mediaItemUrl
    }
    instaLink
    instaIcon {
      altText
      mediaItemUrl
    }
  }
`
